import dynamic from 'next/dynamic'
import ContentSection from '@/components/ContentSection'

const TitleContentBlock = dynamic(() => import('@/components/blocks/TitleContentBlock'))
const TitleContentImageBlock = dynamic(() => import('@/components/blocks/TitleContentImageBlock'))
const TitleContentBeforeAfter = dynamic(() => import('@/components/blocks/TitleContentBeforeAfter'))
const TitleContentGallery = dynamic(() => import('@/components/blocks/TitleContentGallery'))
const TitleContentDirections = dynamic(() => import('@/components/blocks/TitleContentDirections'))
const TitleReviews = dynamic(() => import('@/components/blocks/TitleReviews'))
const TitleContentLink = dynamic(() => import('@/components/blocks/TitleContentLink'))
const TitleAdvantages = dynamic(() => import('@/components/blocks/TitleAdvantages'))
const TitleContentVideo = dynamic(() => import('@/components/blocks/TitleContentVideo'))
const Mission = dynamic(() => import('@/components/blocks/Mission'))
const Doctors = dynamic(() => import('@/components/Doctors'))

export default function generateBlocks(blocks, size, mb, pb="small",swiperData) {
  return blocks.map((block) => {
    const {
      id,
      type,
      data,
      data: { title, slug },
    } = block;
    switch (type) {
      case 'title-content':
        return (
          <ContentSection pt="none" pb={pb} key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleContentBlock data={data} />
          </ContentSection>
        );
      case 'title-content-image':
        return (
          <ContentSection pt="none" pb={pb} key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleContentImageBlock data={data} />
          </ContentSection>
        );
      case 'title-content-images':
        if (data.images.length) {
          return (
            <ContentSection pt="none" pb={pb} key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
              <TitleContentBeforeAfter data={data} />
            </ContentSection>
          );
        } else {
          return (
            <ContentSection pt="none" pb={pb} key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
              <TitleContentGallery data={data} />
            </ContentSection>
          );
        }
      case 'title-content-directions':
        return (
          <ContentSection pt="none" pb="small" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleContentDirections data={data} />
          </ContentSection>
        );
      case 'title-reviews':
        return (
          <ContentSection pt="none" pb="small" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleReviews data={data} swiperData={swiperData}/>
          </ContentSection>
        );
      case 'title-content-link':
        return (
          <ContentSection pt="none" pb="small" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleContentLink data={data} />
          </ContentSection>
        );
      case 'title-advantages':
        return (
          <ContentSection pt="none" pb="small" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleAdvantages data={data} />
          </ContentSection>
        );
      case 'title-content-video':
        return (
          <ContentSection pt="none" pb="small" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <TitleContentVideo data={data} />
          </ContentSection>
        );
      case 'mission':
        return (
          <ContentSection pt="none" pb="large" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <Mission data={data} />
          </ContentSection>
        );
      case 'doctors':
        return (
          <ContentSection pt="none" pb="large" key={id} type="block" title={title} slug={slug} size={size} mb={mb}>
            <Doctors data={data} swiperData={swiperData}/>
          </ContentSection>
        );
      default:
        return;
    }
  });
}
